import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {Button, Grid} from "@mui/material";
import Card from "../../Components/Card";
import ResourceTable, {IGenerateColumns} from "../../Components/ResourceTable";
import {sped} from "../../Requests";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PreserveSped from "./PreserveSped";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import useGlobalContext from "../../Hooks/useGlobalContext";
import RemoveSped from "./RemoveSped";
import EstablishmentSelector from "../../Components/EstablishmentSelector";

const Sped: React.FC = () => {

    const {setLoading: setLoadingGlobal} = useGlobalContext();

    //const [accessProfilesOptions, setAccessProfilesOptions] = useState<IOptions[]>([]);
    const [rechargeRequest, setRechargeRequest] = useState<number>(0);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [idSpedRemove, setIdSpedRemove] = useState<number>(0);
    const [establishmentAliasIdSelecionado, setEstablishmentAliasIdSelecionado] = useState<string | number>('');

    const handleEstablishmentChange = (aliasId: string | number) => {
        setEstablishmentAliasIdSelecionado(aliasId);
    }

    useEffect(() => {
        // Recarrega a tabela quando o estabelecimento mudar
        if (establishmentAliasIdSelecionado) {
            reloadResourceTable();
        }
    }, [establishmentAliasIdSelecionado]);

    const reloadResourceTable = () => {
        setRechargeRequest(n => n + 1);
    }

    const actionViewDelete = (setLoading: Dispatch<SetStateAction<boolean>>) => async (id: number) => {
        setIdSpedRemove(id);
    }

    const openModalNewSped = () => {
        setOpenModal(true);
    }


    const generateColumns: IGenerateColumns = ({setLoading}) => {
        return [
            {field: 'name', headerName: 'Nome do Arquivo', minWidth: 250, flex: 3},
            {field: 'start_date', headerName: 'Data de Início', minWidth: 50, flex: 3},
            {field: 'end_date', headerName: 'Data Final', minWidth: 50, flex: 3},
            {field: 'username', headerName: 'Importado Por', minWidth: 250, flex: 3},
            {field: 'created_at', headerName: 'Data de Importação', minWidth: 250, flex: 3},
            {field: 'status', headerName: 'Status da Importação', minWidth: 250, flex: 3},
            {
                field: 'acao_remover',
                headerName: 'Remover',
                align: 'center',
                headerAlign: 'center',
                flex: 2,
                renderCell: (params: any) => {
                    const status = params?.row?.status;
                    
                    if (status === "Realizando importação") {
                        return "---";
                    }
            
                    return (
                        <div
                            style={{ cursor: 'pointer' }}
                            onClick={() => actionViewDelete(setLoading)(params?.row?.identifier || '')}
                        >
                            <DeleteForeverIcon sx={{ color: '#dc3545' }} />
                        </div>
                    );
                }
            }
            
        ];

    }

    return (<>
        <Grid container spacing={0.5}>
            <Grid item xs={12} sx={{ marginBottom: '20px' }}>
                <Grid container spacing={2} justifyContent="flex-end" alignItems="center" wrap="nowrap">
                    <Grid item xs="auto">
                        <EstablishmentSelector disableCard onChangeEstablishment={handleEstablishmentChange} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12} display='flex' justifyContent='flex-end'>
                <Button variant="contained" sx={{backgroundColor: '#1c2e4a', color: '#FFF'}}
                        onClick={openModalNewSped}>
                    <AddCircleIcon
                        sx={{
                            marginRight: '5px',
                            marginBottom: '2px',
                            // color: '#777777',
                            alignItems: 'baseline'
                        }}
                    /> Importar
                </Button>

                <PreserveSped
                    reloadResourceTable={reloadResourceTable}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    establishmentAliasIdSelecionado={establishmentAliasIdSelecionado}
                />
            </Grid>
            <Card
                titleDashboard='Listagem de Importações de arquivos do SPED Fiscal'
                icon='CloudUploadIcon'
                paperConfig={{minHeight: 704}}
                marginTop='0'
                lineDividerHeader={false}
            >
                {/*{(accessProfilesOptions.length > 0) && */}
                <ResourceTable
                    request={sped}
                    generateColumns={generateColumns}
                    pageSizeOptions={[15]}
                    getRowId={(row) => row?.identifier}
                    minHeight={630}
                    rechargeRequest={rechargeRequest}
                    autoPageSize={true}
                    filterDefinitions={({page,recordsPerPage}) => ({page,recordsPerPage, establishment_alias_id: establishmentAliasIdSelecionado})}
                />
                {/*}*/}
            </Card>
            {(idSpedRemove > 0) && <RemoveSped
                idSped={idSpedRemove}
                reloadResourceTable={reloadResourceTable}
                close={() => setIdSpedRemove(0)}
            />}
        </Grid>
    </>);
}


export default Sped;
